// src/componentFromPromise.js
import React, { Component } from "react";
function componentFromPromise(promiseFn) {
  return class PromiseComponent extends Component {
    constructor() {
      super();
      this.state = {
        LoadedComponent: null
      };
      this._isMounted = false;
    }
    componentDidMount() {
      this._isMounted = true;
      promiseFn().then((LoadedComponent) => {
        if (this._isMounted)
          this.setState({ LoadedComponent });
      });
    }
    componentWillUnmount() {
      this._isMounted = false;
    }
    render() {
      const { LoadedComponent } = this.state;
      return LoadedComponent ? /* @__PURE__ */ React.createElement(LoadedComponent, { ...this.props }) : null;
    }
  };
}

// src/componentFromViewFactory.js
import React2, { Component as Component2 } from "react";
var componentFromViewFactory = (viewFactory, containerProps = {}) => {
  return class FromViewFactory extends Component2 {
    // container = null
    componentDidMount() {
      try {
        if (this.container && viewFactory) {
          this.genericView = viewFactory();
          this.container.appendChild(
            this.genericView.getDOMNode(this.props)
          );
          if (this.genericView.onRender)
            this.genericView.onRender();
        }
      } catch (err) {
        console.error("Failed to render wrapped view", err);
      }
    }
    componentDidUpdate() {
      try {
        if (this.genericView) {
          this.genericView.getDOMNode(this.props);
        }
      } catch (err) {
        console.error("Failed to update wrapped view", err);
      }
    }
    componentWillUnmount() {
      try {
        if (this.genericView && this.genericView.dispose) {
          this.genericView.dispose();
        }
      } catch (err) {
        console.error("Failed to dipose wrapped view");
      }
    }
    render() {
      return /* @__PURE__ */ React2.createElement(
        "div",
        {
          ref: (el) => {
            this.container = el;
          },
          ...containerProps
        }
      );
    }
  };
};
var componentFromViewFactory_default = componentFromViewFactory;

// src/componentFromViewModule.js
var componentFromViewModule = (contrib, moduleProp = void 0, containerProps = {}) => componentFromPromise(
  () => contrib.loadModule(moduleProp).then((m) => componentFromViewFactory_default(m, containerProps))
);
var componentFromViewModule_default = componentFromViewModule;

// src/componentWithProps.js
import React3, { Component as Component3 } from "react";
var componentWithProps = (props) => (Comp) => {
  return class WithProps extends Component3 {
    render() {
      return /* @__PURE__ */ React3.createElement(Comp, { ...props, ...this.props });
    }
  };
};
var componentWithProps_default = componentWithProps;

// src/genericViewFromComponent.js
import React4 from "react";
import ReactDOM from "react-dom";
function genericViewFromComponent(Component4, wrapperClassName = "", rootCustomizer = (x) => x) {
  return function() {
    const root = document.createElement("div");
    root.className = wrapperClassName;
    root.style.height = "100%";
    root.style.width = "100%";
    rootCustomizer(root);
    let rendered = false;
    let tempProps = {};
    return {
      getDOMNode(props) {
        if (rendered) {
          ReactDOM.render(/* @__PURE__ */ React4.createElement(Component4, { ...props }), root);
        } else {
          tempProps = props;
        }
        return root;
      },
      onRender() {
        if (!rendered) {
          ReactDOM.render(/* @__PURE__ */ React4.createElement(Component4, { ...tempProps }), root);
          rendered = true;
          tempProps = null;
        }
      },
      dispose() {
        ReactDOM.unmountComponentAtNode(root);
      }
    };
  };
}

// src/form-toolkit/useForm.js
import React13 from "react";

// src/form-toolkit/withState.js
import React5 from "react";
var withState = (initialState) => (BaseComponent) => class WithState extends React5.Component {
  constructor() {
    super();
    this.state = initialState;
  }
  updateState(updateFn) {
    this.setState(updateFn);
  }
  render() {
    return /* @__PURE__ */ React5.createElement(
      BaseComponent,
      {
        state: this.state,
        setState: (x) => this.updateState(x),
        ...this.props
      }
    );
  }
};

// src/form-toolkit/withData.js
import React6 from "react";
import axios from "axios";
var strOrCallback = (value, props) => {
  if (!value)
    return null;
  if (typeof value === "string")
    return value;
  return value(props);
};
var strToFunction = (option) => {
  if (!option)
    return null;
  if (typeof option === "string")
    return () => option;
  return option;
};
var API = (options, newOptions) => {
  const validate = newOptions.validate || (() => {
  });
  const before = newOptions.before || ((json) => json);
  const success = strToFunction(newOptions.success) || (() => "Settings have been updated.");
  const errorCallback = strToFunction(newOptions.error) || ((_) => "There was a problem submitting your request.");
  const debug = (methodName) => (args) => {
    !!options.debug && console.log(
      "%cAPI",
      "color: #b940b0; font-weight: 600;",
      `[${methodName}]`,
      args
    );
    return args;
  };
  const banner = (response, message, success2 = true) => {
    const type = success2 === true ? "success" : "error";
    return { response, message, type };
  };
  return (payload) => {
    const url = strOrCallback(newOptions.url, payload) || options.url;
    const method = newOptions.method || "POST";
    const request = newOptions.request || ((body) => axios({
      method,
      url,
      data: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    }));
    const logGroup = `API Request [${method} ${url}]`;
    options.debug && console.group(logGroup);
    debug("Payload")(payload);
    return Promise.resolve().then(() => {
      const error = validate(payload);
      debug("Validating Input")({ error });
      if (error) {
        debug("Validation Failed")({ error });
        throw error;
      }
      debug("Input Valid!")("");
    }).then(() => {
      const body = before(payload);
      debug("Parsed Payload")(body);
      debug("Sending Request")("");
      return request(body).then(debug("Request Success!")).then((response) => {
        const message = success(response);
        debug("Parsing Banner Message")({ message });
        return banner(response, message);
      }).catch((err) => {
        debug("Request Failed", err);
        console.error("Request failed: ", err);
        const error = errorCallback(err);
        debug("Parsing Error Message", { err, message: error });
        return banner(err, error, false);
      });
    }).catch((error) => banner({}, error, false)).then((response) => {
      console.groupEnd(logGroup);
      return response;
    });
  };
};
var mapLegacySave = (options) => ({
  url: options.url,
  method: "POST",
  request: options.save,
  before: options.beforeSave,
  success: options.afterSave,
  error: options.onSaveError
});
var withData = (options) => (BaseComponent) => class WithData extends React6.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false
    };
    this.__apis = /* @__PURE__ */ new Map();
    this.__options = options;
    this._fetch = this.__options.fetch || this.fetch;
    this._fetchOnMount = this.__options.fetchOnMount === void 0 ? true : this.__options.fetchOnMount;
    this._onFetch = () => {
    };
    this._onFetchError = () => {
    };
    this._fetchError = this.__options.fetchError || (() => "Something went wrong when fetching your settings.");
    this._afterFetch = this.__options.afterFetch || ((json) => json);
    this._validate = this.__options.validate || (() => {
    });
    this._save = mapLegacySave(options);
    this._debug = this.__options.debug || false;
  }
  onFetch(callback) {
    this._onFetch = callback;
  }
  onFetchError(callback) {
    this._onFetchError = callback;
  }
  useRequest(props) {
    if (this.__apis.has(props))
      return this.__apis.get(props);
    const api = new API(this.__options, props);
    this.__apis.set(props, api);
    return api;
  }
  debug(methodName) {
    return (args) => {
      this._debug && console.log(
        "%cwithData",
        "color: #b940b0; font-weight: 600;",
        `[${methodName}]`,
        args
      );
      return args;
    };
  }
  fetchData() {
    this._debug && console.group("Fetch Data");
    this.debug(`GET ${this.__options.url}`)("");
    return this._fetch(this.__options.url).then(this.debug("Fetch Response")).then(this._afterFetch).then(this.debug("Parsed Response")).then(this._onFetch).catch((err) => {
      this.debug("Fetch Data Failed")(err);
      console.error(err);
      const msg = this._fetchError(err);
      this._onFetchError(msg);
    }).then(() => console.groupEnd("Fetch Data"));
  }
  fetch(url) {
    return axios.get(url).then((data) => data.data);
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return /* @__PURE__ */ React6.createElement(
      BaseComponent,
      {
        fetch: this.fetchData.bind(this),
        save: this._save,
        onFetch: this.onFetch.bind(this),
        onFetchError: this.onFetchError.bind(this),
        useRequest: this.useRequest.bind(this),
        isLoading: this.state.isLoading,
        ...this.props
      }
    );
  }
};

// src/form-toolkit/withFormState.js
import React7 from "react";
var objMap = (obj, callback) => {
  const tmp = {};
  for (var k in obj) {
    const newValue = callback(obj[k]);
    tmp[k] = newValue;
  }
  return tmp;
};
var withFormState = (formProps) => (BaseComponent) => class WithFormState extends React7.Component {
  constructor() {
    super();
    this.state = {
      values: {}
    };
  }
  componentWillMount() {
    const initState = typeof formProps.initialState === "function" ? formProps.initialState(this.props.rootProps) : formProps.initialState;
    this.setState({ values: this.initialValues(initState) });
  }
  initialValues(initialValues) {
    const getType = (value) => {
      if (typeof value === "number") {
        return Number;
      } else if (typeof value === "boolean") {
        return Boolean;
      } else if (typeof value === "string") {
        return String;
      } else {
        return null;
      }
    };
    return objMap(initialValues, (value) => {
      const val = typeof value === "object" && Object.hasOwn(value, "value") ? value.value : value;
      return {
        value: val,
        initial: val,
        touched: false,
        type: value.type || getType(val),
        validate: value.validate || null
      };
    });
  }
  updatedState() {
    return objMap(this.state.values, (value) => {
      if (value.type === Number) {
        return Number(value.value);
      }
      return value.value;
    });
  }
  mergeValue(field, merge) {
    const value = Object.assign({}, this.state.values[field], merge);
    this.setState({
      values: Object.assign({}, this.state.values, { [field]: value })
    });
    return this.updatedState();
  }
  touch(field) {
    this.mergeValue(field, { touched: true });
  }
  set(field, value, setTouched = false) {
    if (!Object.hasOwn(this.state.values, field)) {
      throw `withForm error: Could not set '${field}' to '${value}': Field doesn't exist as part of state.
Check anywhere you may be calling setValue("${field}") and make sure that it is a part of 'initialState'. formState has the following keys: ${Object.keys(
        this.state.values
      )}`;
    }
    const touched = setTouched ? true : this.state.values[field].touched;
    this.mergeValue(field, { value, touched });
    return this.updatedState();
  }
  setMultiple(obj, setTouched = null) {
    const values = Object.assign({}, this.state.values);
    for (var k in obj) {
      if (!Object.hasOwn(values, k)) {
        throw `withForm error: Could not set '${k}' to '${obj[k]}': Field doesn't exist as part of state.
Check anywhere you may be calling setValues({}) and make sure that it is a part of 'initialState'. formState has the following keys: ${Object.keys(
          values
        )}`;
      }
      values[k].touched = setTouched === null ? values[k].touched : setTouched;
      values[k].value = obj[k];
    }
    this.setState({ values });
    return this.updatedState();
  }
  modified() {
    const { values } = this.state;
    const state = this.updatedState();
    for (var k in state) {
      const isDifferent = state[k] !== values[k].initial;
      if (isDifferent) {
        return true;
      }
    }
    return false;
  }
  reset(v) {
    const values = this.state.values;
    for (var k in v) {
      if (Object.hasOwn(values, k)) {
        values[k].initial = v[k];
        values[k].value = v[k];
        values[k].touched = false;
      }
    }
    this.setState({ values });
  }
  clearTouches() {
    const values = objMap(
      this.state.values,
      (value) => Object.assign({}, value, {
        touched: false,
        initial: value.value
      })
    );
    this.setState({
      values
    });
  }
  getErrors() {
    const errors = {};
    for (var k in this.state.values) {
      let validateResults = [];
      const validate = this.state.values[k].validate;
      if (Array.isArray(validate)) {
        validateResults = validate.map(
          (v) => v(this.state.values[k].value)
        );
      } else if (typeof validate === "function") {
        validateResults = validate(this.state.values[k].value);
      }
      if (!Array.isArray(validateResults)) {
        console.error(
          `Validation Error: Invalid result from validation. Expected 'array' but got '${typeof validateResults}'; check the 'validate' prop for '${k}'`,
          { validateResults }
        );
        return /* @__PURE__ */ React7.createElement("div", null);
      }
      errors[k] = validateResults.find((n) => n);
      if (errors[k] !== void 0 && typeof errors[k] !== "string") {
        const index = validateResults.findIndex((n) => n);
        console.error(
          `Validation Error: Expected 'string' in validate function but got '${typeof errors[k]}'. Double check the 'validate' methods in your initial state for '${k}' (#${index + 1})
`,
          { validateResults }
        );
        return /* @__PURE__ */ React7.createElement("div", null);
      }
    }
    return errors;
  }
  render() {
    const values = this.state.values;
    const errors = this.getErrors();
    const touches = Object.keys(values).reduce((res, key) => {
      const obj = values[key];
      return Object.assign(res, {
        [key]: obj.touched
      });
    }, {});
    const hasTouches = !!Object.values(this.state.values).find(
      (n) => n.touched
    );
    const hasErrors = Object.values(errors).find((n) => n);
    return /* @__PURE__ */ React7.createElement(
      BaseComponent,
      {
        values,
        formState: this.updatedState(),
        formWasTouched: hasTouches,
        formHasErrors: hasErrors,
        formWasModified: this.modified(),
        formErrors: errors,
        resetFormState: this.reset.bind(this),
        setValue: this.set.bind(this),
        setValues: this.setMultiple.bind(this),
        setTouched: this.touch.bind(this),
        clearTouches: this.clearTouches.bind(this),
        errors,
        touches,
        ...this.props
      }
    );
  }
};

// src/form-toolkit/withBinds.js
import React8 from "react";
var withBinds = (WrappedComponent) => (props) => {
  const { formState, state, setValue, setTouched, touches, errors } = props;
  const showError = (field) => {
    const touched = touches[field];
    const error = errors[field];
    return error && touched ? error : null;
  };
  const bindInput = (field, formProps) => {
    if (!Object.hasOwn(formState, field))
      throw `withForm error: Could not find key '${field}' while binding - Double check the 'initialState' option in 'useForm' has that key defined
Available keys to bind to: ${Object.keys(
        formProps.initialState
      )}`;
    return Object.assign(
      {
        name: field,
        value: props.values[field].value,
        disabled: props.state.disabled,
        error: showError(field)
      },
      formProps
    );
  };
  const bind = {
    // We assign the {key} prop to force banner to re-render with new state
    // Otherwise we run into the issue of, alert can be set back to null but the component will not re-render
    // (it holds some kind of inner-state)
    /** DnxBanner bind */
    banner: () => !props.formWasTouched && props.state.alert ? Object.assign({ key: Math.random() }, state.alert) : { key: Math.random() },
    /** DnxTextfield */
    textfield: (field) => bindInput(field, {
      input: (e) => setValue(field, e.target.value),
      change: () => setTouched(field)
    }),
    /** DnxDropdown */
    dropdown: (field) => bindInput(field, {
      change: (e) => setValue(field, e.target.value, true)
    }),
    /** DnxSwitch */
    switch: (field) => bindInput(field, {
      change: (e) => {
        setValue(field, e.target.checked, true);
      }
    }),
    switchGroup: (field) => bindInput(field, {
      change: (e) => {
        setValue(field, e.currentTarget.value, true);
      }
    })
  };
  return /* @__PURE__ */ React8.createElement(WrappedComponent, { bindInput: bind, ...props });
};

// src/form-toolkit/withHooks.js
import React9 from "react";
var withHooks = (WrappedComponent) => class withHooks extends React9.Component {
  constructor() {
    super();
    this._effects = {};
  }
  componentWillUnmount() {
    for (var k in this._effects) {
      this.unmountEffect(this._effects[k]);
    }
    this._effects = {};
  }
  unmountEffect(effect) {
    if (effect && typeof effect.unmount === "function") {
      effect.unmount();
    }
  }
  useEffect(id, callback, compare) {
    const effect = this._effects[id];
    if (!compare && effect)
      return;
    if (compare && compare === this._effect.compare)
      return;
    this.unmountEffect(effect);
    this._effects[id] = {
      compare,
      unmount: callback()
    };
  }
  render() {
    let i = 0;
    const useEffect = (callback, compare) => this.useEffect(i++, callback, compare);
    return /* @__PURE__ */ React9.createElement(WrappedComponent, { useEffect, ...this.props });
  }
};

// src/form-toolkit/withLifecycle.js
import React10 from "react";
var withLifecycle = (WrappedComponent) => class WithLifecycle extends React10.Component {
  constructor() {
    super();
    this._onMount = () => {
    };
  }
  componentDidMount() {
    this._onMount();
  }
  onMount(callback) {
    this._onMount = callback;
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return /* @__PURE__ */ React10.createElement(
      WrappedComponent,
      {
        onMount: this.onMount.bind(this),
        ...this.props
      }
    );
  }
};

// src/form-toolkit/withRootProps.js
import React11 from "react";
var withRootProps = (WrappedComponent) => class WithRootProps extends React11.Component {
  render() {
    return /* @__PURE__ */ React11.createElement(WrappedComponent, { rootProps: this.props });
  }
};

// src/form-toolkit/withRef.js
import React12 from "react";
import ReactDom from "react-dom";
var withRef = (WrappedComponent) => class WithLifecycle extends React12.Component {
  constructor() {
    super();
    this.ref = null;
    this.scrollTo = (selector) => {
      const target = this.ref.querySelector(selector);
      if (!target)
        return;
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    };
  }
  componentDidMount() {
    this.ref = ReactDom.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ React12.createElement(WrappedComponent, { scrollTo: this.scrollTo, ...this.props });
  }
};

// src/form-toolkit/useForm.js
var defaultTrueProp = (val) => {
  if (val === void 0)
    return true;
  return val;
};
var readonlyBanner = {
  config: {
    message: `Read only permission for current user role.`,
    type: "information"
  }
};
var compose = (...funcs) => funcs.reduce(
  (a, b) => (...args) => a(b(...args)),
  (arg) => arg
);
var useForm = (formProps) => (WrappedComponent) => {
  const fetchOnMount = defaultTrueProp(formProps.fetchOnMount);
  const isReadonly = formProps.readonly ? formProps.readonly() : false;
  const withPageState = withState({
    isLoading: false,
    disabled: isReadonly,
    submitting: false,
    alert: isReadonly ? readonlyBanner : {}
  });
  const WithForm = ({
    // withRootProps
    rootProps,
    // withRef
    scrollTo,
    // withLifecycle
    onMount,
    useEffect,
    // withData
    fetch,
    onFetch,
    onFetchError,
    save,
    useRequest,
    // withFormState
    resetFormState,
    formState,
    values,
    setValue,
    setValues,
    bindInput,
    clearTouches,
    errors,
    touches,
    setTouched,
    formWasModified,
    formHasErrors,
    // withState
    state,
    setState
  }) => {
    const debug = (name, data) => {
      if (!formProps.debug)
        return;
      console.log(
        "%cuseForm",
        "color: #3e7798; font-weight: 600;",
        `[${name}]`,
        Object.assign({}, { state, values }, data)
      );
    };
    const mergeState = (newState) => setState(
      (state2) => Object.assign(
        {},
        state2,
        newState,
        isReadonly ? {
          disabled: true,
          alert: readonlyBanner
        } : {}
      )
    );
    const clearAlert = () => mergeState({ alert: null });
    onMount(() => {
      if (!fetchOnMount)
        return;
      mergeState({
        isLoading: true,
        disabled: true
      });
      fetch();
    });
    onFetch((data) => {
      debug("Fetched data", { data });
      resetFormState(data);
      mergeState({ isLoading: false, disabled: false });
    });
    onFetchError((error) => {
      debug("Fetch Error - There was a problem fetching from the API: ", {
        error
      });
      mergeState({
        alert: {
          config: { message: error, type: "error" }
        }
      });
    });
    const onRequestDone = (response) => {
      debug("Submit to the API finished!", { response });
      clearTouches();
      mergeState({
        submitting: false,
        disabled: false,
        isLoading: false,
        alert: {
          config: response,
          close: clearAlert
        }
      });
      scrollTo(".focus-on-response");
    };
    const useRequestWithState = (...args) => {
      const api = useRequest.apply(null, args);
      return () => {
        debug("Begin API Request");
        mergeState({
          isLoading: true,
          disabled: true,
          alert: null
        });
        return api(formState).then((response) => {
          onRequestDone(response);
          return response;
        });
      };
    };
    const submit = () => {
      return useRequestWithState(save);
    };
    const bind = Object.assign({}, bindInput, {
      submit: () => ({
        label: "Save",
        disabled: state.disabled || !formWasModified || !!formHasErrors,
        click: () => {
          submit();
        }
      })
    });
    return /* @__PURE__ */ React13.createElement(
      WrappedComponent,
      {
        state,
        mergeState,
        formState,
        bind,
        submit,
        setValue,
        setValues,
        resetFormState,
        useRequest: useRequestWithState,
        useEffect,
        errors,
        touches,
        setTouched,
        scrollTo,
        props: rootProps
      }
    );
  };
  return compose(
    withRootProps,
    withLifecycle,
    withRef,
    withData(formProps),
    withFormState(formProps),
    withPageState,
    withBinds,
    withHooks
  )(WithForm);
};

// src/form-toolkit/Validators.js
import { regex } from "*external*/@cisco-dna/dnx-web-components";
var validators = {
  isRequired: (v) => !v && "This field is required"
};
for (k in regex) {
  const reg = regex[k].regex;
  const message = regex[k].message;
  const name = k.charAt(0).toUpperCase() + k.slice(1);
  validators[`is${name}`] = (v) => !reg.test(v) && message;
}
var k;
var Validate = new Proxy(validators, {
  get: function(obj, prop) {
    if (!Object.hasOwn(obj, prop)) {
      throw `Validator '${prop}' doesn't exist. Please pick from one of the following:
${Object.keys(
        validators
      )}`;
    }
    return validators[prop];
  }
});
export {
  Validate,
  componentFromPromise,
  componentFromViewFactory_default as componentFromViewFactory,
  componentFromViewModule_default as componentFromViewModule,
  componentWithProps_default as componentWithProps,
  genericViewFromComponent,
  useForm
};
//# sourceMappingURL=index.mjs.map